import Image from 'next/image';
import classnames from 'classnames';

export default function Authors({ people, expand = true, showTitle = false }) {
  return people.map(({ name, photo: image, title }, index) => (
    <span
      className={classnames('inline-flex items-center relative z-10', {
        'mx-3': expand,
        'ml-[-16px]': !expand,
      })}
      key={index}
    >
      {image && (
        <div
          className={classnames(
            'inline-flex rounded-full border-2 border-white bg-gray-200',
            {
              'mr-3': expand,
            },
          )}
        >
          <Image
            src={image.url}
            title={name}
            alt={name}
            width={36}
            height={36}
            objectFit="cover"
            className="flex rounded-full"
          />
        </div>
      )}

      {expand && (
        <div className="text-sm md:text-base">
          {name}
          {showTitle && title && (
            <span className="text-cornflower text-xs uppercase font-bold block">
              {title}
            </span>
          )}
        </div>
      )}
    </span>
  ));
}
